import { log } from "./debug";
import {getPaymentMethods} from './pay'; 
  
function isGeopoint(geo){
  const result =  geo && geo.latitude!=0.0 && geo.longitude!=0.0
  return Boolean(result); 
}


const getStoreData = (newLocation,view,strings)=>{
  const takeorder =newLocation.takeorder; 
  const language = strings.meta_lang
  const geopoint  = {
     latitude: newLocation.latitude,
     longitude:newLocation.longitude
    };

  const isDeliveryActive =  isDeliveryRatesActive(takeorder) && isGeopoint(geopoint); 

  const store ={
    id       :  newLocation.id,
    view     :  view,
    name     :  newLocation.name,
    isDemo        :isDemo(takeorder),
    
    activeRates   :  isDeliveryActive,
    maxDistance   :  getMaxDistance(takeorder), 
    normalRates   :  deliveryNormalRates(takeorder), 
    extendedRates :  deliveryExtendedRates(takeorder), 
    payMethods    :  getPaymentMethods(newLocation,view,language),
    pickupService:   getPickUpService(takeorder),
    disableTakeaway: takeorder?.disableTakeaway,
    disableDelivery :takeorder?.disableDelivery,
    textTicket:      getTextTicket(takeorder),

    clientInfo:  getClientInfo(newLocation,view),
  
    geopoint :  geopoint,   
    address  :  newLocation.address, 
    trakingOrder: newLocation.team!=undefined,
    phone:  parseToWhatsapp(takeorder?.whatsapp.phone),
    type: newLocation.type,
    additions: newLocation.additions, 

    // Functions 
    requestPaymentMethod(){
       return this.payMethods?.length>0
    },

    requestClientInfo(){
     return this.clientInfo?true:false
    }

  };
  //console.debug('getStoreData: ',store);
  log.message('store','getStoreData:',store); 
  return store;
  
}


const getClientInfo = (location,view)=>{
  let clientInfo=location.takeorder?.clientInfo; 
  if(view==="LOCAL"){
    clientInfo = location.selforder?.clientInfo;
  }
  return mapClientInfoToStore(clientInfo); 
}

const mapClientInfoToStore = (clientInfo)=>{
  if(clientInfo?.active!=true) return null; 

  const hasRequestInfo =  clientInfo.name==true || 
                          clientInfo.phone==true ||
                          clientInfo.message==true;

 if(!hasRequestInfo) return null;  
 return {
      name: clientInfo.name, 
      phone: clientInfo.phone,
      message: clientInfo.message
    } 
}

const parseToWhatsapp=(phone)=>{
  const whatsNumber = phone?.replace("-","");
  return whatsNumber; 
}


const getPickUpService = (takeorder)=>{
  return (takeorder && takeorder.pickup && takeorder.pickup.active)
}

const isDeliveryRatesActive = ( takeorder)=>{
    return takeorder?.deliveryRates ?
     takeorder?.deliveryRates.active: false
}

const getMaxDistance = (takeorder)=>{
      const normal = deliveryNormalRates(takeorder); 
      const extended = deliveryExtendedRates(takeorder); 
      const maxNormal = normal.hasRates? normal.radius:0; 
      const maxExtended = extended.hasRates? extended.maxRadius:0;
    return maxExtended>maxNormal? maxExtended: maxNormal; 
}

const deliveryNormalRates = (takeorder) => {
  if(!takeorder || !takeorder.deliveryRates || !takeorder.deliveryRates.active)
     return {hasRates:false}
  const hasActiveNormalRates = takeorder && takeorder.deliveryRates &&
                        takeorder.deliveryRates.radius>0; 
  const price = takeorder.deliveryRates.price; 
  const radius= takeorder.deliveryRates.radius; 
  return {
      hasRates: hasActiveNormalRates, 
      price: price, 
      radius:radius, 
 }; 
}
const deliveryExtendedRates = (takeorder) => {
  if(!takeorder || !takeorder.deliveryRates || !takeorder.deliveryRates.active)
     return {hasRates:false}

     const hasActiveExtraRates = takeorder && takeorder.deliveryRates &&
     takeorder.deliveryRates.maxRadius>takeorder.deliveryRates.radius &&
     takeorder.deliveryRates.priceByKm>0; 

  return {
      hasRates: hasActiveExtraRates , 
      priceByKm: takeorder.deliveryRates.priceByKm, 
      maxRadius:takeorder.deliveryRates.maxRadius, 
 }; 
}

const getTextTicket = (takeorder) => {
  if(!takeorder || !takeorder.whatsapp)
    return false;
  return takeorder.whatsapp.textTicket?true:false;
}
const isDemo = (takeorder) => {
  if(!takeorder || !takeorder?.isDemo)
    return false;
  return takeorder?.isDemo;
}

const getTakeOrderVersion=(takeorder) => {
    if(!takeorder || !takeorder?.version) return  0
    return takeorder?.version
}

  const rad = (x) => {
    return x * Math.PI / 180;
  };
  


export {
   getStoreData,
   getTakeOrderVersion
  }; 